import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { BsModalService } from 'ngx-bootstrap/modal';
import { map, switchMap } from 'rxjs/operators';
import { AdaptiveRulesComponent } from '../../adaptive-rules/adaptive-rules.component';
import { ConfirmDialogResult } from '../modal/modal-confirm.component';
import { TopNavigationBarActions } from './top-navigation-bar.actions';

@Injectable()
export class TopNavigationBarEffects {

    constructor(
        private actions$: Actions,
        private modalService: BsModalService) {
    }
    openConfirmDialog$ = createEffect(() =>
        this.actions$
            .pipe(
                ofType(TopNavigationBarActions.openAdaptiveRule),
                switchMap((action: any) => {
                    const modalRef = this.modalService
                        .show(AdaptiveRulesComponent,
                            {
                                initialState: {
                                    okLabel: 'Save',
                                    cancelLabel: 'Close'
                                },
                                backdrop: 'static',
                                class: 'modal-lg',
                                keyboard: false // disable esc key
                            });

                    return modalRef.content.onClose;
                }),
                map((dialogResult: ConfirmDialogResult) => { // map dialog result into action (map function returns observable to action)
                    if (dialogResult.isConfirmed) {
                        // Used cancelled saving
                        return TopNavigationBarActions.openAdaptiveRuleCancel();
                    }
                })
            )
    );
}
